// eslint-disable-next-line camelcase
import ModelFactory from '../model-factory';
import { BaseModel } from '../models';
import { Ticket } from '../ticket';
import { KnowledgeItem } from '../knowledgeItems';

export default class GlobalSearchResult extends BaseModel {
  constructor(opts = {}) {
    super(opts);

    const {
      // eslint-disable-next-line camelcase
      collection_cr = {},
      // eslint-disable-next-line camelcase
      collection_knowledge = {},
      // eslint-disable-next-line camelcase
      collection_nr = {},
    } = opts;

    this.matchedId = opts.matched_id || false;

    this.requests = {
      total: collection_cr['@TOTAL_COUNT'] || 0,
      start: collection_cr['@START'] || 0,
      list: [],
    };

    // eslint-disable-next-line camelcase
    if (collection_cr && collection_cr.cr && collection_cr.cr.length > 0) {
      this.requests.list = collection_cr.cr.map((data) => new Ticket(data));
    }

    this.knowledgeItems = {
      total: collection_knowledge['@TOTAL_COUNT'] || 0,
      start: collection_knowledge['@START'] || 0,
      list: [],
    };

    // eslint-disable-next-line camelcase
    if (collection_knowledge && (collection_knowledge.knowledge || []).length > 0) {
      const list = collection_knowledge.knowledge;
      this.knowledgeItems.list = list.map((data) => new KnowledgeItem(data));
    }

    this.catalogItems = {
      total: collection_nr['@TOTAL_COUNT'] || 0,
      start: collection_nr['@START'] || 0,
      list: [],
    };

    // eslint-disable-next-line camelcase
    if (collection_nr && collection_nr.nr && collection_nr.nr.length > 0) {
      this.catalogItems.list = collection_nr.nr.map((data) => new Ticket(data));
    }
  }
}

export const formatGlobalSearchResult = (data) => {
  const modelFactory = new ModelFactory('global_search', (res) => new GlobalSearchResult(res));
  return modelFactory.format(data);
};
